import SignIn, { PATH as SIGN_IN } from './SignIn';
import SignUp, { PATH as SIGN_UP } from './SignUp';
import ForgotPassword, { PATH as FORGOT_PASSWORD } from './ForgotPassword';
import ResetPassword, { PATH as RESET_PASSWORD } from './ResetPassword';

export default { SignIn, SignUp, ForgotPassword, ResetPassword };
export const PATH = { SIGN_IN, SIGN_UP, FORGOT_PASSWORD, RESET_PASSWORD };
